
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "documents-public-ui",
  currentProjectVersion: "static-1.35575",
  depVersions: {
  "documents-public-ui": "static-1.35575",
  "atom": "static-1.5566",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2982",
  "client-types": "static-1.512",
  "cssUtils": "static-1.1116",
  "customer-data-filters-ui": "static-1.41429",
  "customer-data-objects": "static-1.8203",
  "customer-data-property-utils": "static-1.8546",
  "documents-lib": "static-1.35580",
  "emoji-mart": "static-3.9",
  "flux-actions": "static-1.383",
  "FormsCommonComponents": "static-1.86868",
  "FormUrlGenerator": "static-2.5208",
  "foundations-theming-specialty": "static-1.2700",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5330",
  "highcharts": "static-8.117",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6086",
  "hs-test-utils": "static-1.8533",
  "hub-http": "static-1.6700",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12287",
  "HubStyleTokens": "static-2.11980",
  "I18n": "static-7.1714",
  "icons": "static-2.707",
  "jasmine-immutable": "static-1.3430",
  "jasmine-runner": "static-1.6947",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7640",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3376",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5874",
  "quartz": "static-1.7692",
  "react": "static-7.204",
  "react-dlb": "static-1.96",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1-fkhalid-vitals-reporter-delete-lcp.3",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5673",
  "react-virtualized": "static-2.114",
  "reference-resolvers": "static-1.8679",
  "reference-resolvers-lite": "static-1.8607",
  "reporting-data": "static-1.69418",
  "reporting-reports": "static-1.69094",
  "reporting-snowflake": "static-1.58034",
  "reporting-testing-lib": "static-1.11351",
  "reporting-visualizations": "static-1.61492",
  "reselect": "static-3.18",
  "sales-content-partitioning": "static-1.9454",
  "sanitize": "static-1.4969",
  "sanitize-text": "static-1.8652",
  "SharedI18nStrings": "static-1.190",
  "SharedLegalStrings": "static-1.2221",
  "signup-constants": "static-1.19977",
  "signup-ui-url-generator": "static-2.8532",
  "StyleGuideUI": "static-3.520",
  "superstore": "static-1.5251",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5244",
  "ui-addon-form-validation": "static-1.11351",
  "ui-asset-management-lib": "static-1.11595",
  "ui-images": "static-2.1281",
  "UIComponents": "static-3.8926",
  "usage-tracker": "static-1.7816",
  "usage-tracker-container": "static-1.7806",
  "usage-tracker-core": "static-1.7666",
  "viral-links-lib": "static-1.7578",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10133",
  "foundations-components": "static-1.8777",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.458",
  "quartz-config": "static-1.1470",
  "quartz-core": "static-1.6911",
  "quick-fetch": "static-1.4242",
  "raven": "static-3.6411",
  "redux": "static-4.81",
  "redux-thunk": "static-2.86",
  "rpc-client-utils": "static-1.5163",
  "ui-addon-i18n": "static-1.11640",
  "ui-addon-upgrades": "static-9.18555",
  "enviro": "static-4.523",
  "hs-promise-rejection-tracking": "static-1.6078",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3969",
  "quartz-webpack": "static-1.3916",
  "foundations-assets": "static-1.5382",
  "foundations-theming": "static-1.4984",
  "hub-http-janus": "static-1.912",
  "hub-http-shared-msw-handlers": "static-1.10933",
  "hubspotter-http": "static-1.4986",
  "trellis-components": "static-1.3153",
  "trellis-migration-context": "static-1.76",
  "sassPrefix": "static-1.381",
  "conversations-skeleton-state": "static-1.7613",
  "crm-message-bus": "static-1.44145",
  "customer-data-filters-ui-msw-helpers": "static-1.23864",
  "customer-data-objects-ui-components": "static-1.13529",
  "customer-data-reference-ui-components": "static-1.13668",
  "customer-data-ui-utilities": "static-1.10325",
  "events-data-lib": "static-1.741",
  "framework-builder-read-service-client": "static-1.4346",
  "hs-resources": "static-1.678",
  "immer": "static-1.107",
  "inbound-db-meta-service-client": "static-1.3785",
  "inbound-db-properties-service-client": "static-1.4161",
  "multi-account-reference-resolvers": "static-1.1506",
  "onboarding-tours": "static-1.17416",
  "pulse": "static-1.1143",
  "reporting-datasets-permissions-lib": "static-1.14801",
  "segments-client-types": "static-1.12231",
  "stylex": "static-1.48",
  "trellis-assets": "static-1.3134",
  "trellis-theming": "static-1.1509",
  "ui-addon-teams": "static-1.22032",
  "quartz-auth": "static-1.1367",
  "ui-business-units-lib": "static-1.9591",
  "usage-tracker-session-replay": "static-1.5502",
  "ai-components-ui-library": "static-1.10057",
  "ContentUtils": "static-1.69517",
  "customer-data-properties": "static-1.53112",
  "forms-ai-lib": "static-1.5007",
  "forms-utils-lib": "static-1.13364",
  "foundations-components-test-utils": "static-1.6260",
  "react-dnd-compat": "static-1.5104",
  "react-tinymce": "static-1.56303",
  "tinymce-config": "static-2.55429",
  "ui-gdpr-components": "static-1.10658",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3969",
  "HeadJS": "static-2.828",
  "framer-motion": "static-1.86",
  "hs-test-utils-bend-plugin": "static-1.3644",
  "msw": "static-1.105",
  "msw-config": "static-1.34",
  "testing-library": "static-1.167",
  "hs-locale-management": "static-1.412",
  "ui-fonts": "static-1.1242",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4800",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.194",
  "quartz-head": "static-1.1357",
  "web-vitals": "static-1.21",
  "batch-promise": "static-1.2043",
  "external-options-client-types": "static-1.4449",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1367",
  "frontend-preferences-client": "static-1.8416",
  "graphql": "static-1.95",
  "persist-promise": "static-1.4200",
  "reporting-client-types": "static-1.2853",
  "apollo-stack-hubspot": "static-3.101",
  "hubspot-apollo-client": "static-1.5377",
  "foundations-components-legacy": "static-1.1802",
  "quartz-routing": "static-1.1122",
  "hs-story-utils": "static-1.9923",
  "react-flip-move": "static-1.85",
  "nested-table": "static-1.726",
  "seat-types-lib": "static-1.1079",
  "timezone-utils": "static-2.5725",
  "react-create-root-preference": "static-1.110",
  "bend-plugin-foundations-components": "static-1.5046",
  "floating-ui": "static-1.70",
  "react-aria": "static-1.79",
  "tanstack-table": "static-1.68",
  "opentelemetry-fe-types": "static-1.285",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.611",
  "module-federation": "static-1.41",
  "opentelemetry-fe": "static-1.660",
  "quartz-test": "static-1.1367",
  "quartz-tracking": "static-1.1071",
  "bend-plugin-chirp-manifest": "static-1.573",
  "chirp-fetch": "static-1.2398",
  "merchandise-lib": "static-1.288",
  "purchase-motions-components": "static-1.6657",
  "ts-schema": "static-1.4406",
  "bender-build-tools": "static-1.3604",
  "bend-plugin-foundations-theming": "static-1.3467",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "restore-request-side-panel-lib": "static-1.2067",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5082",
  "conditional-properties-service-client": "static-1.4125",
  "crm-pipelines-api-client-types": "static-1.4455",
  "event-emitter": "static-1.1455",
  "fdsr-migration-layer": "static-1.507",
  "multi-currency-client-types": "static-1.4020",
  "getting-started-shared-tasks": "static-1.19596",
  "growth-data-modal": "static-1.6162",
  "growth-onboarding-confetti": "static-1.3553",
  "growth-onboarding-next-action-utils": "static-1.3018",
  "navigation-components": "static-1.19207",
  "nest": "static-1.730",
  "onboarding-tours-client": "static-1.5631",
  "onboarding-tours-utils": "static-1.1483",
  "ui-shepherd-react": "static-3.10774",
  "ui-shepherd-tracker": "static-1.8155",
  "ui-universal-auth": "static-1.9777",
  "user-context": "static-1.5548",
  "bend-plugin-pulse": "static-1.646",
  "fast-json-patch": "static-1.76",
  "crm-index-associations-lib": "static-1.6942",
  "stylex-utils": "static-1.180",
  "hubspotter-http-shared-msw-handlers": "static-1.10931",
  "magpie-lib": "static-1.5924",
  "navigation-messaging": "static-1.8534",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23991",
  "copilot-toolkit": "static-1.12184",
  "cms-field-types": "static-1.5304",
  "content-icons-ui": "static-1.2475",
  "integrations-lib": "static-1.17470",
  "calling-global-api": "static-1.66245",
  "calling-internal-common": "static-1.31819",
  "calling-lifecycle-internal": "static-1.67627",
  "calling-lifecycle-messages": "static-1.59919",
  "commerce-products-lib": "static-1.10960",
  "crm-index-visualization-core": "static-1.4783",
  "crm-links": "static-1.6807",
  "customer-data-properties-shared-msw-handlers": "static-1.10260",
  "data-agent-utils": "static-1.966",
  "file-manager-components": "static-1.24871",
  "formula-editor": "static-1.15034",
  "google-libphonenumber": "static-1.52",
  "inbounddb-objects-service-types": "static-1.4526",
  "meetings-icalendar-utils-lib": "static-1.1126",
  "object-builder-ui-client": "static-1.50092",
  "pipeline-validation-client-types": "static-1.4295",
  "property-value-citations": "static-1.3726",
  "smart-data-capture-core": "static-1.522",
  "tiered-pricing": "static-1.2314",
  "topics-actions-lib": "static-1.678",
  "trellis-ext-i18n": "static-1.1416",
  "trial-components-library": "static-1.14414",
  "ui-addon-iframeable": "static-1.9573",
  "zustand": "static-1.91",
  "final-form": "static-1.85",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.84",
  "rich-text-lib": "static-1.20586",
  "tinymce-themes": "static-1.57399",
  "data-token-picker": "static-1.17164",
  "hub-http-contrib": "static-1.3527",
  "interframe": "static-3.5236",
  "tinymce-data": "static-1.41514",
  "tinymce-plugins": "static-1.58543",
  "ui-addon-sales-email": "static-1.5696",
  "hubspot-apollo-cache": "static-1.836",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.645",
  "opentelemetry-web": "static-1.25",
  "onboarding-scopes": "static-1.6948",
  "purchase-motions-api": "static-1.6660",
  "onboarding-data-sync-lib": "static-1.2865",
  "growth-onboarding-next-action-components": "static-1.3046",
  "user-context-client": "static-1.5004",
  "idb-keyval": "static-1.57",
  "magpie-types": "static-1.5384",
  "reactive-lib": "static-1.1215",
  "simple-logging-lib": "static-1.3545",
  "custom-vendor-connection-lib": "static-1.341",
  "unified-auth-core-lib": "static-1.1573",
  "getting-started-shared-tasks-store": "static-1.18714",
  "nav-meta": "static-1.30844",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2245",
  "integrations-error-boundary-lib": "static-1.14885",
  "integrations-tracking-lib": "static-1.6117",
  "native-integrations-shared-strings": "static-1.8257",
  "redux-observable": "static-1.81",
  "ReduxMessenger": "static-2.10865",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31826",
  "shared-worker-versioning": "static-1.11538",
  "calling-usage-tracker": "static-1.7035",
  "customer-data-tracking": "static-1.7367",
  "voice-sms-access-library": "static-1.2502",
  "commerce-permissions": "static-1.1280",
  "growth-payments-core": "static-1.26535",
  "products-iframe-lib": "static-1.8950",
  "products-ui-components-shared-msw-handlers": "static-1.11315",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11016",
  "sales-views-client-types": "static-1.4753",
  "framework-data-schema-resolvers": "static-1.7388",
  "location-customization-utils-lib": "static-1.10456",
  "data-agent-kit": "static-1.953",
  "enrichment-settings-lib": "static-1.270",
  "fsm": "static-1.4251",
  "policy-lib": "static-1.7298",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4636",
  "poll-commands": "static-1.3972",
  "video-components-external": "static-1.12479",
  "video-data-lib": "static-1.36137",
  "bark-lib": "static-1.17028",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.108",
  "crm-properties-common-lib": "static-1.6391",
  "react-codemirror": "static-1.11136",
  "embedded-academy-lib": "static-1.16063",
  "hubs-service-types": "static-1.1761",
  "nudge-client-utils": "static-1.3451",
  "salesImages": "static-1.752",
  "FileManagerLib": "static-1.40511",
  "react-colorpicker": "static-2.10704",
  "NamespacedHubStyle": "static-2.9379",
  "FileManagerCore": "static-1.40370",
  "content-assistance-lib": "static-1.8448",
  "layout-dnd-components": "static-1.13256",
  "layout-dnd-utils": "static-1.12231",
  "ui-addon-emoji-picker": "static-1.10358",
  "ui-brand-identity-lib": "static-1.16994",
  "InboxConnectUtils": "static-4.15875",
  "meetings-connect-utils-lib": "static-1.8114",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1223",
  "breeze-engine-core": "static-1.1523",
  "highlight.js": "static-1.92",
  "universal-page-editor-lib": "static-1.3507",
  "calling-orchestration-schema": "static-1.37279",
  "ui-addon-opt": "static-4.8909",
  "framework-data-schema-quick-fetch": "static-1.7293",
  "crm-record-cards-service-types": "static-1.3873",
  "trellis-story-utils": "static-1.4993",
  "storybook-react": "static-1.46",
  "content-media-composition-data-lib": "static-1.13631",
  "content-media-compositions": "static-2.17638",
  "media-bridge-lib": "static-1.19669",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16700",
  "browser-eslint": "static-2.57",
  "academy-common-lib": "static-1.15524",
  "nudge-custom-function-registry": "static-1.3208",
  "nudge-renderer-utils": "static-1.3527",
  "whisper-core-api": "static-1.7670",
  "audio-components": "static-1.6599",
  "FileManagerImages": "static-1.38022",
  "video-components": "static-1.14481",
  "breeze-artifacts-sdk": "static-1.1046",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30088",
  "html-to-image": "static-1.67",
  "urlinator": "static-1.5007",
  "video-embed": "static-1.36971",
  "ui-addon-video-player": "static-1.9117",
  "ui-coaching-tips": "static-1.29603",
  "ContentData": "static-1.69592",
  "layout-data-lib": "static-1.10556",
  "crm-record-cards-client": "static-1.96",
  "academy-service-client": "static-1.4185",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4890",
  "trellis-ecosystem": "static-1.7879",
  "ui-addon-react-router-dom": "static-1.10020",
  "wootric-nps": "static-1.7309",
  "social-insights-client-types": "static-1.22960",
  "outpost": "static-1.4624",
  "growth-onboarding-feedback-components": "static-1.7075",
  "advanced-menus-core": "static-1.15845",
  "advanced-menus-lib": "static-1.12591",
  "ExportDialog": "static-6.10867",
  "ui-memberships-settings-lib": "static-1.35235",
  "marketplace-ui-apps-core": "static-1.19587",
  "marketplace-ui-common": "static-1.21055",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15844",
  "simple-menus-lib": "static-1.17361",
  "settings-ui-lib": "static-1.13023",
  "developer-experience-shared-components": "static-1.11036",
  "immutable-less": "static-1.5146",
  "marketplace-ui-client-types": "static-1.18462",
  "ui-addon-integrations-directory-panel": "static-2.8448",
  "ui-extensibility-client-types": "static-1.4409",
  "ai-settings-ui-library": "static-1.8622",
  "ui-product-approvals-common": "static-1.1633",
  "apps-service-types": "static-1.4103",
  "oauth-service-types": "static-1.4630",
  "simple-data-table": "static-1.3856"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35575",
  "atom": "/atom/static-1.5566",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2982",
  "client-types": "/client-types/static-1.512",
  "cssUtils": "/cssUtils/static-1.1116",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41429",
  "customer-data-objects": "/customer-data-objects/static-1.8203",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8546",
  "documents-lib": "/documents-lib/static-1.35580",
  "emoji-mart": "/emoji-mart/static-3.9",
  "flux-actions": "/flux-actions/static-1.383",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86868",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5208",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2700",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5330",
  "highcharts": "/highcharts/static-8.117",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6086",
  "hs-test-utils": "/hs-test-utils/static-1.8533",
  "hub-http": "/hub-http/static-1.6700",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12287",
  "HubStyleTokens": "/HubStyleTokens/static-2.11980",
  "I18n": "/I18n/static-7.1714",
  "icons": "/icons/static-2.707",
  "jasmine-immutable": "/jasmine-immutable/static-1.3430",
  "jasmine-runner": "/jasmine-runner/static-1.6947",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7640",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3376",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5874",
  "quartz": "/quartz/static-1.7692",
  "react": "/react/static-7.204",
  "react-dlb": "/react-dlb/static-1.96",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-vitals-reporter-delete-lcp.3",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5673",
  "react-virtualized": "/react-virtualized/static-2.114",
  "reference-resolvers": "/reference-resolvers/static-1.8679",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8607",
  "reporting-data": "/reporting-data/static-1.69418",
  "reporting-reports": "/reporting-reports/static-1.69094",
  "reporting-snowflake": "/reporting-snowflake/static-1.58034",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11351",
  "reporting-visualizations": "/reporting-visualizations/static-1.61492",
  "reselect": "/reselect/static-3.18",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9454",
  "sanitize": "/sanitize/static-1.4969",
  "sanitize-text": "/sanitize-text/static-1.8652",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2221",
  "signup-constants": "/signup-constants/static-1.19977",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8532",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "superstore": "/superstore/static-1.5251",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5244",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11351",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11595",
  "ui-images": "/ui-images/static-2.1281",
  "UIComponents": "/UIComponents/static-3.8926",
  "usage-tracker": "/usage-tracker/static-1.7816",
  "usage-tracker-container": "/usage-tracker-container/static-1.7806",
  "usage-tracker-core": "/usage-tracker-core/static-1.7666",
  "viral-links-lib": "/viral-links-lib/static-1.7578",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10133",
  "foundations-components": "/foundations-components/static-1.8777",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "quartz-config": "/quartz-config/static-1.1470",
  "quartz-core": "/quartz-core/static-1.6911",
  "quick-fetch": "/quick-fetch/static-1.4242",
  "raven": "/raven/static-3.6411",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.86",
  "rpc-client-utils": "/rpc-client-utils/static-1.5163",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11640",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18555",
  "enviro": "/enviro/static-4.523",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3969",
  "quartz-webpack": "/quartz-webpack/static-1.3916",
  "foundations-assets": "/foundations-assets/static-1.5382",
  "foundations-theming": "/foundations-theming/static-1.4984",
  "hub-http-janus": "/hub-http-janus/static-1.912",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10933",
  "hubspotter-http": "/hubspotter-http/static-1.4986",
  "trellis-components": "/trellis-components/static-1.3153",
  "trellis-migration-context": "/trellis-migration-context/static-1.76",
  "sassPrefix": "/sassPrefix/static-1.381",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7613",
  "crm-message-bus": "/crm-message-bus/static-1.44145",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23864",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13529",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13668",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10325",
  "events-data-lib": "/events-data-lib/static-1.741",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4346",
  "hs-resources": "/hs-resources/static-1.678",
  "immer": "/immer/static-1.107",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3785",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4161",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1506",
  "onboarding-tours": "/onboarding-tours/static-1.17416",
  "pulse": "/pulse/static-1.1143",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14801",
  "segments-client-types": "/segments-client-types/static-1.12231",
  "stylex": "/stylex/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.3134",
  "trellis-theming": "/trellis-theming/static-1.1509",
  "ui-addon-teams": "/ui-addon-teams/static-1.22032",
  "quartz-auth": "/quartz-auth/static-1.1367",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9591",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5502",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10057",
  "ContentUtils": "/ContentUtils/static-1.69517",
  "customer-data-properties": "/customer-data-properties/static-1.53112",
  "forms-ai-lib": "/forms-ai-lib/static-1.5007",
  "forms-utils-lib": "/forms-utils-lib/static-1.13364",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6260",
  "react-dnd-compat": "/react-dnd-compat/static-1.5104",
  "react-tinymce": "/react-tinymce/static-1.56303",
  "tinymce-config": "/tinymce-config/static-2.55429",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3969",
  "HeadJS": "/HeadJS/static-2.828",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3644",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.34",
  "testing-library": "/testing-library/static-1.167",
  "hs-locale-management": "/hs-locale-management/static-1.412",
  "ui-fonts": "/ui-fonts/static-1.1242",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4800",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.194",
  "quartz-head": "/quartz-head/static-1.1357",
  "web-vitals": "/web-vitals/static-1.21",
  "batch-promise": "/batch-promise/static-1.2043",
  "external-options-client-types": "/external-options-client-types/static-1.4449",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1367",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8416",
  "graphql": "/graphql/static-1.95",
  "persist-promise": "/persist-promise/static-1.4200",
  "reporting-client-types": "/reporting-client-types/static-1.2853",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.101",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5377",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1802",
  "quartz-routing": "/quartz-routing/static-1.1122",
  "hs-story-utils": "/hs-story-utils/static-1.9923",
  "react-flip-move": "/react-flip-move/static-1.85",
  "nested-table": "/nested-table/static-1.726",
  "seat-types-lib": "/seat-types-lib/static-1.1079",
  "timezone-utils": "/timezone-utils/static-2.5725",
  "react-create-root-preference": "/react-create-root-preference/static-1.110",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5046",
  "floating-ui": "/floating-ui/static-1.70",
  "react-aria": "/react-aria/static-1.79",
  "tanstack-table": "/tanstack-table/static-1.68",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.285",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.611",
  "module-federation": "/module-federation/static-1.41",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.660",
  "quartz-test": "/quartz-test/static-1.1367",
  "quartz-tracking": "/quartz-tracking/static-1.1071",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.573",
  "chirp-fetch": "/chirp-fetch/static-1.2398",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "purchase-motions-components": "/purchase-motions-components/static-1.6657",
  "ts-schema": "/ts-schema/static-1.4406",
  "bender-build-tools": "/bender-build-tools/static-1.3604",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3467",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2067",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5082",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4125",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4455",
  "event-emitter": "/event-emitter/static-1.1455",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.507",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4020",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19596",
  "growth-data-modal": "/growth-data-modal/static-1.6162",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3553",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3018",
  "navigation-components": "/navigation-components/static-1.19207",
  "nest": "/nest/static-1.730",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5631",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1483",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10774",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8155",
  "ui-universal-auth": "/ui-universal-auth/static-1.9777",
  "user-context": "/user-context/static-1.5548",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.646",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6942",
  "stylex-utils": "/stylex-utils/static-1.180",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10931",
  "magpie-lib": "/magpie-lib/static-1.5924",
  "navigation-messaging": "/navigation-messaging/static-1.8534",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23991",
  "copilot-toolkit": "/copilot-toolkit/static-1.12184",
  "cms-field-types": "/cms-field-types/static-1.5304",
  "content-icons-ui": "/content-icons-ui/static-1.2475",
  "integrations-lib": "/integrations-lib/static-1.17470",
  "calling-global-api": "/calling-global-api/static-1.66245",
  "calling-internal-common": "/calling-internal-common/static-1.31819",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67627",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59919",
  "commerce-products-lib": "/commerce-products-lib/static-1.10960",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4783",
  "crm-links": "/crm-links/static-1.6807",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10260",
  "data-agent-utils": "/data-agent-utils/static-1.966",
  "file-manager-components": "/file-manager-components/static-1.24871",
  "formula-editor": "/formula-editor/static-1.15034",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4526",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1126",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50092",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4295",
  "property-value-citations": "/property-value-citations/static-1.3726",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.522",
  "tiered-pricing": "/tiered-pricing/static-1.2314",
  "topics-actions-lib": "/topics-actions-lib/static-1.678",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1416",
  "trial-components-library": "/trial-components-library/static-1.14414",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9573",
  "zustand": "/zustand/static-1.91",
  "final-form": "/final-form/static-1.85",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "rich-text-lib": "/rich-text-lib/static-1.20586",
  "tinymce-themes": "/tinymce-themes/static-1.57399",
  "data-token-picker": "/data-token-picker/static-1.17164",
  "hub-http-contrib": "/hub-http-contrib/static-1.3527",
  "interframe": "/interframe/static-3.5236",
  "tinymce-data": "/tinymce-data/static-1.41514",
  "tinymce-plugins": "/tinymce-plugins/static-1.58543",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5696",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.836",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.645",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "onboarding-scopes": "/onboarding-scopes/static-1.6948",
  "purchase-motions-api": "/purchase-motions-api/static-1.6660",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2865",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3046",
  "user-context-client": "/user-context-client/static-1.5004",
  "idb-keyval": "/idb-keyval/static-1.57",
  "magpie-types": "/magpie-types/static-1.5384",
  "reactive-lib": "/reactive-lib/static-1.1215",
  "simple-logging-lib": "/simple-logging-lib/static-1.3545",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.341",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1573",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18714",
  "nav-meta": "/nav-meta/static-1.30844",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2245",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14885",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6117",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8257",
  "redux-observable": "/redux-observable/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10865",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31826",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11538",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7035",
  "customer-data-tracking": "/customer-data-tracking/static-1.7367",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2502",
  "commerce-permissions": "/commerce-permissions/static-1.1280",
  "growth-payments-core": "/growth-payments-core/static-1.26535",
  "products-iframe-lib": "/products-iframe-lib/static-1.8950",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11315",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11016",
  "sales-views-client-types": "/sales-views-client-types/static-1.4753",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7388",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10456",
  "data-agent-kit": "/data-agent-kit/static-1.953",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.270",
  "fsm": "/fsm/static-1.4251",
  "policy-lib": "/policy-lib/static-1.7298",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4636",
  "poll-commands": "/poll-commands/static-1.3972",
  "video-components-external": "/video-components-external/static-1.12479",
  "video-data-lib": "/video-data-lib/static-1.36137",
  "bark-lib": "/bark-lib/static-1.17028",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.108",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6391",
  "react-codemirror": "/react-codemirror/static-1.11136",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16063",
  "hubs-service-types": "/hubs-service-types/static-1.1761",
  "nudge-client-utils": "/nudge-client-utils/static-1.3451",
  "salesImages": "/salesImages/static-1.752",
  "FileManagerLib": "/FileManagerLib/static-1.40511",
  "react-colorpicker": "/react-colorpicker/static-2.10704",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9379",
  "FileManagerCore": "/FileManagerCore/static-1.40370",
  "content-assistance-lib": "/content-assistance-lib/static-1.8448",
  "layout-dnd-components": "/layout-dnd-components/static-1.13256",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12231",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10358",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16994",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15875",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8114",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1223",
  "breeze-engine-core": "/breeze-engine-core/static-1.1523",
  "highlight.js": "/highlight.js/static-1.92",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3507",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37279",
  "ui-addon-opt": "/ui-addon-opt/static-4.8909",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7293",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3873",
  "trellis-story-utils": "/trellis-story-utils/static-1.4993",
  "storybook-react": "/storybook-react/static-1.46",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13631",
  "content-media-compositions": "/content-media-compositions/static-2.17638",
  "media-bridge-lib": "/media-bridge-lib/static-1.19669",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16700",
  "browser-eslint": "/browser-eslint/static-2.57",
  "academy-common-lib": "/academy-common-lib/static-1.15524",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3208",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3527",
  "whisper-core-api": "/whisper-core-api/static-1.7670",
  "audio-components": "/audio-components/static-1.6599",
  "FileManagerImages": "/FileManagerImages/static-1.38022",
  "video-components": "/video-components/static-1.14481",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1046",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30088",
  "html-to-image": "/html-to-image/static-1.67",
  "urlinator": "/urlinator/static-1.5007",
  "video-embed": "/video-embed/static-1.36971",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9117",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29603",
  "ContentData": "/ContentData/static-1.69592",
  "layout-data-lib": "/layout-data-lib/static-1.10556",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.96",
  "academy-service-client": "/academy-service-client/static-1.4185",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4890",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7879",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10020",
  "wootric-nps": "/wootric-nps/static-1.7309",
  "social-insights-client-types": "/social-insights-client-types/static-1.22960",
  "outpost": "/outpost/static-1.4624",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7075",
  "advanced-menus-core": "/advanced-menus-core/static-1.15845",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12591",
  "ExportDialog": "/ExportDialog/static-6.10867",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35235",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19587",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21055",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15844",
  "simple-menus-lib": "/simple-menus-lib/static-1.17361",
  "settings-ui-lib": "/settings-ui-lib/static-1.13023",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11036",
  "immutable-less": "/immutable-less/static-1.5146",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18462",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8448",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4409",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8622",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1633",
  "apps-service-types": "/apps-service-types/static-1.4103",
  "oauth-service-types": "/oauth-service-types/static-1.4630",
  "simple-data-table": "/simple-data-table/static-1.3856"
}
};
